import { useQuery } from "@tanstack/react-query";

import { MODULE_NAMES } from "@/constants/modules";
import { TEN_MINUTES_MS } from "@/constants/time";
import { LIST_QUERY_KEY } from "@/utils/query";

import { RADIUS_VPN_PREFIX } from "./constants";
import { fetchRadiusVpnServersListData } from "./radiusVpnServersApi";

export const useRadiusVpnServers = () =>
  useQuery({
    queryKey: [MODULE_NAMES.RADIUS_VPN_SERVERS, LIST_QUERY_KEY, "custom"],
    queryFn: async () => {
      const { data = [] } = await fetchRadiusVpnServersListData({
        filter: {
          pagination: false,
        },
      });

      return {
        radiusVpnServersList: data,
        radiusVpnServersChoices: data.map((model) => ({
          id: RADIUS_VPN_PREFIX + (model.id || ""),
          name: model.host,
        })),
        radiusVpnObjectsMap: data.reduce(
          (acc, model) => {
            if (model["@id"]) {
              acc[model["@id"]] = model;
            }
            return acc;
          },
          {} as Record<string, (typeof data)[number]>,
        ),
      };
    },
    staleTime: TEN_MINUTES_MS,
  });
